import { useMutation } from '@tanstack/react-query';

import { trackEvent } from '@/lib/analytics';

import { saveStep, type SaveInput } from '../api/application-api';
import { useSetMe } from '../queries';
import { nextAfterSave, type Destination, type Step } from '../steps';

/** Saves one step, updates the cached record, and reports where to go next. */
export function useSaveStep(step: Step, onNext: (to: Destination) => void) {
  const setMe = useSetMe();
  return useMutation({
    mutationFn: (input: SaveInput) => saveStep(input),
    onSuccess: (saved) => {
      setMe(saved);
      trackEvent('step_completed', { step });
      if (step === 'contact' || step === 'contact_waiting') trackEvent('application_submitted');
      onNext(nextAfterSave(saved, step));
    },
  });
}
